export default class PageI18nNameKeys {
  public static readonly LOGIN = 'auth.title';
  public static readonly REGISTRATION = 'registration.title';
  public static readonly FORGOTTEN_PASSWORD = 'forgottenPassword.title';
  public static readonly VERIFICATION = 'verification.title';
  public static readonly VERIFY = 'verify.title';
  public static readonly APPROVE_MANAGED_CARD = 'manageCardConfirmationPage.title';
  public static readonly CHANGE_PASSWORD = 'changePassword.title';
  public static readonly USER_ACCOUNT = 'userAccount.title';
  public static readonly USER_ASSIGNED_ACCOUNT = 'assignedAccount.title';
  public static readonly NOTIFICATION_SETTING = 'notificationSetting.title';
  public static readonly TICKET_FARE = 'ticketFare.title';
  public static readonly ELECTRONIC_WALLET = 'electronicWallet.title';
  public static readonly SHOPPING_CART = 'shoppingCart.title';
  public static readonly ORDER_LIST = 'orderList.title';
  public static readonly ACCOUNT_SETTING = 'accountSetting.title';
  public static readonly ASSIGNED_CARD_LIST = 'assignedCardList.title';
  public static readonly MANAGED_CARD_LIST = 'managedCardList.title';
  public static readonly CARD_MANAGING_ACCOUNT_LIST = 'cardManagingAccountList.title';
  public static readonly REJECT_CARD_MANAGE_REQUEST = 'rejectCardManageRequestPage.title';
  public static readonly PUBLIC_OFFENSES_SEARCH = 'global.searchOffense';
  public static readonly PUBLIC_OFFENSES_DETAIL = 'global.offenseDetails';
  public static readonly ENVIRONMENT_VARIABLES = 'environmentVariableSetting.title';
}
